import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("kvm_token");
    const savedAdmin = localStorage.getItem("kvm_admin");
    if (token && savedAdmin) {
      try {
        setAdmin(JSON.parse(savedAdmin));
        // Verify token is still valid
        api.get("/auth/me").catch(() => {
          logout();
        });
      } catch {
        logout();
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const response = await api.post("/auth/login", { email, password });
    const { token, email: adminEmail, name } = response.data;
    localStorage.setItem("kvm_token", token);
    localStorage.setItem("kvm_admin", JSON.stringify({ email: adminEmail, name }));
    setAdmin({ email: adminEmail, name });
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem("kvm_token");
    localStorage.removeItem("kvm_admin");
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within AuthProvider");
  return context;
};
